// extracted by mini-css-extract-plugin
export var cardIcon = "_aw-4";
export var checkboxCard = "_aw-0";
export var checkboxCardSelected = "_aw-3";
export var disabled = "_aw-1";
export var outerBorder = "_aw-2";
export var spacerMedium = "_aw-7";
export var spacerSmall = "_aw-6";
export var spacerXsmall = "_aw-5";